import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import CIOServicePage from "@/pages/CIOServicePage";
import InfraServicePage from "@/pages/InfraServicePage";
import ERPServicePage from "@/pages/ERPServicePage";
import CyberServicePage from "@/pages/CyberServicePage";
import AIServicePage from "@/pages/AIServicePage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/cio" element={<CIOServicePage />} />
          <Route path="/services/infrastructure" element={<InfraServicePage />} />
          <Route path="/services/erp" element={<ERPServicePage />} />
          <Route path="/services/cybersecurity" element={<CyberServicePage />} />
          <Route path="/services/ai" element={<AIServicePage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
